export const mapping_sheet = [
  {
    SysCode: "AwaitingCustomerRevertTask",
    msg: "Accept updated terms",
  },
  {
    SysCode: "AwaitingPPMCVendorResponseTask",
    msg: "Medical report pending",
  },
  {
    SysCode: "AwaitingUWPPMCVendorResponse",
    msg: "Medical report pending",
  },
  {
    SysCode: "PendingUWRequirementFulfillmentTask",
    msg: "Medical report is awaited and additional requirement is analyzed by UW",
  },
  {
    SysCode: "PendingUWRequirements1",
    msg: "Medical report pending & documents required",
  },
  {
    SysCode: "PendingUWRequirementsTask",
    msg: "Medical report pending & documents required",
  },
  {
    SysCode: "PendingUWTask",
    msg: "Medical report pending & UW decision pending",
  },
  {
    SysCode: "WaitingForUWRequirement",
    msg: "Medical report pending & Requirement raised by UW",
  },
  {
    SysCode: "WaitingForUWRequirement1",
    msg: "Medical report pending & Requirement raised by UW",
  },
  {
    SysCode: "AwaitingUWPPMCVendorResponseForPPMCTask",
    msg: "Medical report pending",
  },
  {
    SysCode: "AwaitingUWPPMCVendorResponseTask",
    msg: "Application under review",
  },
  {
    SysCode: "CustomerRevertUpdateTask",
    msg: "Application under review",
  },
  {
    SysCode: "DataEntryDiscrepancy",
    msg: "Application under review",
  },
  {
    SysCode: "DocScrutinyPendingTask",
    msg: "KYC Documents pending",
  },
  {
    SysCode: "DocScrutinyTask",
    msg: "KYC Documents under review",
  },
  {
    SysCode: "HUMSFailureTask",
    msg: "Application under review",
  },
  {
    SysCode: "PaymentCheckTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingDEAfterFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingDeDupCheckTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingInstalmentPremiumClearanceTask",
    msg: "Payment Pending",
  },
  {
    SysCode: "PendingInstalmentPremiumTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingIPASUWTransferTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingLetterDispatchTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingOpsClarification",
    msg: "Application under review",
  },
  {
    SysCode: "PendingPaymentReceivedTask",
    msg: "Payment Pending",
  },
  {
    SysCode: "PendingPaymentReceivedTask",
    msg: "Payment Pending",
  },
  {
    SysCode: "PendingPaymentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingPrintingDispatchTask",
    msg: "Refund Initiated",
  },
  {
    SysCode: "PendingProposalDataEntryTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingQCAfterFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingQCTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingRequirementFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingRequirementsTask",
    msg: "Documents required",
  },
  {
    SysCode: "PendingRequirementsTask1",
    msg: "Documents required",
  },
  {
    SysCode: "PendingRequirementsTask2",
    msg: "Documents required",
  },
  {
    SysCode: "PendingReverseFeedTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingTeleUWTask",
    msg: "Schedule Tele Underwriting",
  },
  {
    SysCode: "PendingUWPPMC",
    msg: "Book Medical appointment",
  },
  {
    SysCode: "PendingUWPPMCForPPMCTask",
    msg: "Book Medical appointment",
  },
  {
    SysCode: "PendingUWPPMCTask",
    msg: "Book Medical appointment",
  },
  {
    SysCode: "PendingUWPPMCWaitTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWRequirementFulfillmentAddInfoTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWRequirementFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWRequirements",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "PendingUWRequirements1",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "PendingUWRequirements2",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "PendingUWRequirementsForAddInfoTask",
    msg: "Documents required",
  },
  {
    SysCode: "PendingUWRequirementsForAddInfoTask1",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWRequirementsTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWWaiverFulfillment",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWWaiverFulfillmentAddInfoTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingUWWaiverFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PendingWaiverFulfillmentTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyAdvanceEnforcedTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyAutoClearanceTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyExpiredTask",
    msg: "Policy Expired",
  },
  {
    SysCode: "PolicyEnforcedTask",
    msg: "Policy Issued",
  },
  {
    SysCode: "PolicyLapsedTask",
    msg: "Policy Lapsed",
  },
  {
    SysCode: "PolicyPreIssuanceTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyPremiumFulfiledTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyProcessCompleteTask",
    msg: "Application under review",
  },
  {
    SysCode: "PolicyRejectedTask",
    msg: "Policy Rejected",
  },
  {
    SysCode: "PolicyTerminatedTask",
    msg: "Policy Terminated",
  },
  {
    SysCode: "PPMCUWWaiverApproval",
    msg: "Application under review",
  },
  {
    SysCode: "PPMCUWWaiverApprovalForPPMCTask",
    msg: "Application under review",
  },
  {
    SysCode: "PPMCWaiverApprovalTask",
    msg: "Application under review",
  },
  {
    SysCode: "PPMCWaiverTask",
    msg: "Application under review",
  },
  {
    SysCode: "PropReceiptCaptureTask",
    msg: "Application under review",
  },
  {
    SysCode: "RefundProcess",
    msg: "Refund initiated",
  },
  {
    SysCode: "RetryCustomerContactTask",
    msg: "Customer Not reachable",
  },
  {
    SysCode: "SendBackToPPMCTask",
    msg: "Application under review",
  },
  {
    SysCode: "SentBackToDE",
    msg: "Application under review",
  },
  {
    SysCode: "STPTask",
    msg: "Pending Issuance",
  },
  {
    SysCode: "UploadFailureTask",
    msg: "Application under review",
  },
  {
    SysCode: "UWRetryCustomerContactForPPMCTask",
    msg: "Customer Not reachable",
  },
  {
    SysCode: "WaitingForIssuanceTask",
    msg: "Pending Issuance",
  },
  {
    SysCode: "WaitingForPaymentClearanceTask",
    msg: "Application under review",
  },
  {
    SysCode: "WaitingForRequirementTask",
    msg: "Application under review",
  },
  {
    SysCode: "WaitingForRequirementTask",
    msg: "Application under review",
  },
  {
    SysCode: "WaitingForUW Requirement",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "WaitingForUW Requirement1",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "WaitingForUWRequirement2",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "WaitingForUWRequirementAddInfoTask",
    msg: "Application under review",
  },
  {
    SysCode: "WaitingForUWRequirementAddInfoTask1",
    msg: "Requirement raised by UW",
  },
  {
    SysCode: "WaitingForUWRequirementTask",
    msg: "Application under review",
  },
  {
    SysCode: "Add Info Received",
    msg: "Requirement received",
  },
  {
    SysCode: "Add Info Waiver Requested",
    msg: "Requirement received",
  },
  {
    SysCode: "PPMC Received",
    msg: "Medical reports received",
  },
  {
    SysCode: "PPMC Waiver Requested",
    msg: "Medical test waiver requested",
  },
  {
    SysCode: "PPMC Unsuccessful",
    msg: "Medical tests pending",
  },
  {
    SysCode: "PPMC + Add Info Received",
    msg: "Requirements Received + Medical Reports received",
  },
  {
    SysCode: "PPMC Received + Add Info Pending",
    msg: "Medical Reports received + Requirement pending",
  },
  {
    SysCode: "PPMC Pending + Add Info Recevied",
    msg: "Medical tests pending + Requirement received",
  },
  {
    SysCode: "PPMC + Add Info Waiver Requested",
    msg: "Requirements Received + Medical Reports received",
  },
  {
    SysCode: "Incomplete PPMC",
    msg: "Medical reports pending",
  },
  {
    SysCode: "Incomplete PPMC + Add Info Pending",
    msg: "Medicals reports pending + Requirements pending",
  },
  {
    SysCode: "Incomplete PPMC + Add info received",
    msg: "Medicals reports pending + Requirements received",
  },
  {
    SysCode: "UW Complete_Waiver Requested",
    msg: "Application under review",
  },
  {
    SysCode: "UW Complete_Cust Acceptance Received",
    msg: "Underwriting Completed",
  },
  {
    SysCode: "UW Complete_Cust Acceptance Rejected",
    msg: "Underwriting Completed",
  },
  {
    SysCode: "Add Info Pending",
    msg: "Requirement Pending",
  },
  {
    SysCode: "Add Info Waiver Approved",
    msg: "Requirement received",
  },
  {
    SysCode: "Add Info Waiver Rejected",
    msg: "Requirement Pending",
  },
  {
    SysCode: "PPMC Pending",
    msg: "Medical tests pending",
  },
  {
    SysCode: "PPMC Waiver Approved",
    msg: "Medical test waiver approved",
  },
  {
    SysCode: "PPMC Waiver Rejected",
    msg: "Medical test waiver rejected",
  },
  {
    SysCode: "PPMC + Add Info Pending",
    msg: "Medical tests pending + Requirement pending",
  },
  {
    SysCode: "PPMC + Add Info Waiver Approved",
    msg: "Requirements waiver approved + Medical tests waiver approved",
  },
  {
    SysCode: "PPMC + Add Info Waiver Rejected",
    msg: "Medical test waiver rejected + Requirements waiver rejected",
  },
  {
    SysCode: "PPMC + Add Info Partial Waiver Approved",
    msg: "Medical test pending + Requirements pending",
  },
  {
    SysCode: "Referred  To Sr Underwriter",
    msg: "Application under review",
  },
  {
    SysCode: "UW Complete_Loading Waived",
    msg: "Loading Waived",
  },
  {
    SysCode: "UW Complete_Sp Cond Waived",
    msg: "Special Condition Waived",
  },
  {
    SysCode: "UW Complete_Loading + Sp Cond Waived",
    msg: "Special Condition + Loading Waived",
  },
  {
    SysCode: "UW Pending",
    msg: "Application under review",
  },
  {
    SysCode: "UW Complete",
    msg: "Underwriting Completed",
  },
  {
    SysCode: "UW Complete_Cust Acceptance Awaited",
    msg: "Underwriting Completed",
  },
  {
    SysCode: "Referral response recd",
    msg: "Application under review",
  },
  {
    SysCode: "New APP",
    msg: "Application under review",
  },
  {
    SysCode: "New App + PPMC Pending",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "Approve STP",
    msg: "Pending Issuance",
  },
  {
    SysCode: "New Renewal App",
    msg: "Application under review",
  },
  {
    SysCode: "Renewals Pending",
    msg: "Application under review",
  },
  {
    SysCode: "New Renewal App + PPMC Pending ",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "Renewals PPMC Pending",
    msg: "Medical Reports pending",
  },
  {
    SysCode: "RenewalUWPending+PPMC",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "TeleUWPending",
    msg: "Tele underwriting  Pending",
  },
  {
    SysCode: "Send back to Ops",
    msg: "Application under review",
  },
  {
    SysCode: "OpsResponseRequirementComplete",
    msg: "Application under review",
  },
  {
    SysCode: "OpsResponseRequirementIncomplete",
    msg: "Application under review",
  },
  {
    SysCode: "New App+PPMC",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "UWPending+PPMC",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "NewRenewalApp+PPMC",
    msg: "Medical test pending+Medical test pending",
  },
  {
    SysCode: "Send back to PPMC",
    msg: "Medical Reports pending",
  },
  {
    SysCode: "Add Info Received + PPMC Waiver Requested",
    msg: "Requirements received + Medical Reports received",
  },
  {
    SysCode: "Add Info Waiver Requested + PPMC Waiver Requested",
    msg: "Requirements received + Medical Reports received",
  },
  {
    SysCode: "NewAppTeleUWPending",
    msg: "Tele Underwriting  Pending",
  },
  {
    SysCode: "TeleUWComplete",
    msg: "Tele Underwriting Completed",
  },
  {
    SysCode: "RetryCustomer",
    msg: "Customer not reachable",
  },
  {
    SysCode: "TeleUWattemptedCustomerNotContactable",
    msg: "Customer not contactable for Tele Underwriting",
  },
  {
    SysCode: "AutoRejected",
    msg: "Decision screen will be shown",
  },
  {
    SysCode: "Accept with Same Terms",
    msg: "Accept with Same Terms",
  },
  {
    SysCode: "Accept with Loading",
    msg: "Loading added",
  },
  {
    SysCode: "Accept with Sp Conditions",
    msg: "Special Condition applied",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions",
    msg: "Loading added + Special condition applied",
  },
  {
    SysCode: "Reject",
    msg: "Policy Rejected",
  },
  {
    SysCode: "Approve STP",
    msg: "Pending Issuance",
  },
  {
    SysCode: "Accept_Loading Waiver",
    msg: "Loading added",
  },
  {
    SysCode: "Accept_Spl Cond Waiver",
    msg: "Special Condition applied",
  },
  {
    SysCode: "Accept_Loading + Spl Cond Waiver",
    msg: "Loading added + Special condition applied",
  },
  {
    SysCode: "Accept _Loading waived_Spl Cond Applicable",
    msg: "Loading Waived + Special condition applied",
  },
  {
    SysCode: "Accept_Spl Cond Waived_Loading applicable",
    msg: "Loading added + Special condition Waived",
  },
  {
    SysCode: "Decision Pending ",
    msg: "Application under Review",
  },
  {
    SysCode: "Terminate",
    msg: "Policy Terminated",
  },
  {
    SysCode: "Cancellation",
    msg: "Policy Cancelled",
  },
  {
    SysCode: "Freelook",
    msg: "Policy Freelook cancellation",
  },
  {
    SysCode: "AcceptWithCounterOffer",
    msg: "Counter offer applied",
  },
  {
    SysCode: "AcceptWithLoadingCounterOffer",
    msg: "Loading added + Counter offer applied",
  },
  {
    SysCode: "AcceptWithSpConditionsCounterOffer",
    msg: "Special Condition applied + Counter offer applied",
  },
  {
    SysCode: "AcceptWithLoadingSpConditionsCounterOffer",
    msg: "Special Condition applied + Loading added  + Counter offer applied",
  },
  {
    SysCode: "PPMC_WAIVER_REQUESTED_ADD_INFO_PENDING",
    msg: "PPMC Waiver Requested + Add Info Pending",
  },
  {
    SysCode: "PPMC_PENDING_ADDINO_WAIVER_REQUESTED",
    msg: "PPMC Pending + Add Info Waiver Requested",
  },
  {
    SysCode: "PPMC_RECEIVED_ADDINFO_WAIVER_REQUESTED",
    msg: "PPMC Received + Add Info Waiver Requested",
  },
  {
    SysCode: "PPMC_WAIVER_APPROVED_ADD_INFO_PENDING",
    msg: "PPMC Waiver Approved  + Add Info Pending",
  },
  {
    SysCode: "PPMC_WAIVER_APPROVED_ADD_INFO_RECEVIED",
    msg: "PPMC Waiver Approved  + Add Info Recevied",
  },
  {
    SysCode: "PPMC_WAIVER_REJECTED_ADD_INFO_PENDING",
    msg: "PPMC Waiver Rejected + Add Info Pending",
  },
  {
    SysCode: "PPMC_WAIVER_REJECTED_ADD_INFO_RECEIVED",
    msg: "PPMC Waiver Rejected + Add Info Received",
  },
  {
    SysCode: "PPMC_WAIVER_APPROVED_ADD_INFO_WAIVER_REQUESTED",
    msg: "PPMC Waiver Approved + Add info Waiver Requested",
  },
  {
    SysCode: "RejectForTermination",
    msg: "Reject For Termination",
  },
  {
    SysCode: "Accept with Co payment",
    msg: "Accept with Co payment",
  },
  {
    SysCode: "Accept with Deductible",
    msg: "Accept with Deductible",
  },
  {
    SysCode: "Accept with Co payment + Deductible",
    msg: "Accept with Co payment + Accept with Deductible",
  },
  {
    SysCode: "Accept with Loading + Co payment",
    msg: "Loading added + Accept with Co payment",
  },
  {
    SysCode: "Accept with Loading + Deductible",
    msg: "Loading added +  Accept with Deductible",
  },
  {
    SysCode: "Accept with Loading + Co payment + Deductible",
    msg: "Loading added + Accept with Co payment + Accept with Deductible",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions + Co payment",
    msg: "Loading added + Special Condition applied + Accept with Co payment",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions + Deductible",
    msg: "Loading added + Special Condition applied + Accept with Deductible",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions + Co payment + Deductible",
    msg: "Loading added + Special Condition applied + Accept with Co payment + Accept with Deductible",
  },
  {
    SysCode: "Accept with Sp Conditions + Co payment",
    msg: "Special Condition applied + Accept with Co payment",
  },
  {
    SysCode: "Accept with Sp Conditions + Deductible",
    msg: "Special Condition applied + Accept with Deductible",
  },
  {
    SysCode: "Accept with Sp Conditions + Co payment + Deductible",
    msg: "Special Condition applied + Accept with Co payment + Accept with Deductible",
  },
  {
    SysCode: "Accept with Co payment CounterOffer",
    msg: "Accept with Co payment + Counter offer applied",
  },
  {
    SysCode: "Accept with Deductible CounterOffer",
    msg: "Accept with Deductible + Counter offer applied",
  },
  {
    SysCode: "Accept with Loading + Co payment + CounterOffer",
    msg: "Loading added + Accept with Co payment + Counter offer applied",
  },
  {
    SysCode: "Accept with Loading + Deductible + CounterOffer",
    msg: "Loading added + Accept with Deductible +  Counter offer applied",
  },
  {
    SysCode: "Accept with Sp Conditions + Co payment + CounterOffer",
    msg: "Special Condition applied + Accept with Co payment + Counter offer applied",
  },
  {
    SysCode: "Accept with Sp Conditions + Deductible + CounterOffer",
    msg: "Special Condition applied + Accept with Deductible + Counter offer applied",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions + Co payment + CounterOffer",
    msg: "Loading Added + Special Condition applied +  Accept with Co payment + Counter offer applied",
  },
  {
    SysCode: "Accept with Loading + Sp Conditions + Deductible + CounterOffer",
    msg: "Loading Added + Special Condition applied +  Accept with Deductible + Counter offer applied",
  },
  {
    SysCode:
      "Accept with Loading + Sp Conditions + Co payment + Deductible + CounterOffer",
    msg: `Loading Added + Special Condition applied +  Accept with Co payment +
    Accept with Deductible + Counter offer applied`,
  },
  {
    SysCode: "Accept with Co payment + Deductible + CounterOffer",
    msg: "Accept with Co payment + Accept with Deductible + Counter offer applied",
  },
  {
    SysCode:
      "Accept with Sp Conditions + Co payment + Deductible + CounterOffer",
    msg: "Special Condition applied + Accept with Co payment + Accept with Deductible + Counter offer applied",
  },
  {
    SysCode: "Accept with Loading + Co payment + Deductible + CounterOffer",
    msg: "Loading Added + Accept with Co payment + Accept with Deductible + Counter offer applied",
  },
];

export const pending_status_code = [
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Pan Card verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Passport Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Voter Id card Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Driving license Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Job Card issued by NREGA  Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg:
      "Letter issued by National population registrar Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Aadhar Card Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg:
      "Letter from Gazetted Officer with duly attested photograph  Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Passport Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "VoterId Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Driving License Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Aadhar Card Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Telephone Bill Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Bank Passbook Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Electricity Bill Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Accomodation Letterb Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Property or municipal tax letter Verification Completed",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "COMPLETED",
    Frontend_msg: "Photo Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "RECEIVED",
    Frontend_msg: "Verification is Under Progress",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "PANCOPYREQD",
    Frontend_msg: "PANCARD is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "CLEARPANCOPYREQD",
    Frontend_msg: "Clear PANCARD required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "PANDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on PANCARD",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "PANNAMEMISMATCH",
    Frontend_msg: "Name mismatch on PANCARD",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "PANINCORRECT",
    Frontend_msg: "Incorrect PANCARD uploaded",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTCOPYREQD",
    Frontend_msg: "Passport is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "CLEARPPCOPYREQD",
    Frontend_msg: "Clear Passport required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTNAMEMISMATCH",
    Frontend_msg: "Name mismatch on Passport",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Passport",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "VALIDPASSPORTREQUIRED",
    Frontend_msg: "Valid Passport required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTINCORRECT",
    Frontend_msg: "Incorrect Passport uploaded",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTEIDCOPYREQD",
    Frontend_msg: "Voter ID Card is required/Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "CLEARVOTEIDCOPYREQD",
    Frontend_msg: "Clear Voter ID Card required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDINCORRECT",
    Frontend_msg: "Incorrect Voter ID Card uploaded",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Voter ID Card",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VALIDVOTEIDREQUIRED",
    Frontend_msg: "Valid Voter ID Card required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Voter ID Card",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSECOPYREQD",
    Frontend_msg: "Driving license is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "CLEARDLICESSECOPYREQD",
    Frontend_msg: "Clear Driving license required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSENAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Driving license",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSEDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Driving license",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "VALIDDLICESSEREQUIRED",
    Frontend_msg: "Valid Driving license required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSEINCORRECT",
    Frontend_msg: "Incorrect Driving license uploaded",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "JOBCARDREQD",
    Frontend_msg: "Job Card issued by NREGA is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "CLEARJOBCARDCOPYREQD",
    Frontend_msg: "Clear Job Card issued by NREGA required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "JOBCARDNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Job Card issued by NREGA",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "VALIDJOBCARDREQUIRED",
    Frontend_msg: "Valid Job Card issued by NREGA required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "LETTERHEADREQD",
    Frontend_msg:
      "Letter issued by National Population Register is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "CLEARLETTERHEADCOPYREQD",
    Frontend_msg:
      "Clear Letter issued by National Population Register required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "LETTERHEADNAMEMISMATCH",
    Frontend_msg:
      "Name Mismatch on Letter issued by National Population Register",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARCOPYREQD",
    Frontend_msg: "Aadhar is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "CLEARAADHARCOPYREQD",
    Frontend_msg: "Clear Aadhar required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Aadhar",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Aadhar",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARINCORRECT",
    Frontend_msg: "Incorrect Aadhar uploaded",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARNOMISSING",
    Frontend_msg: "Complete Aadhar Number Required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "GAZETTEOFFICERREQD",
    Frontend_msg:
      "Letter from Gazetted Officer with duly attested photograph is required/ Missing",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "CLEARGAZETTEOFFICERCOPYREQD",
    Frontend_msg:
      "Clear Letter from Gazetted Officer with duly attested photograph required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "GAZETTEOFFICERNAMEMISMATCH",
    Frontend_msg:
      "Name Mismatch on Letter from Gazetted Officer with duly attested photograph",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTCOPYREQD",
    Frontend_msg: "Passport is required/Passport Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "CLEARPPCOPYREQD",
    Frontend_msg: "Clear Passport required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Passport",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Passport",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTINCORRECT",
    Frontend_msg: "Incorrect Passport uploaded",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "PASSPORTADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Passport",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "VALIDPASSPORTREQUIRED",
    Frontend_msg: "Valid Passport required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTEIDCOPYREQD",
    Frontend_msg: "Voter ID Card is required/Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "CLEARVOTEIDCOPYREQD",
    Frontend_msg: "Clear Voter ID Card required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDINCORRECT",
    Frontend_msg: "Incorrect Voter ID Card uploaded",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Voter ID Card",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Voter ID Card",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VOTERIDADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Voter ID Card",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "VALIDVOTEIDREQUIRED",
    Frontend_msg: "Valid Voter ID Card required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSECOPYREQD",
    Frontend_msg: "Driving license is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "CLEARDLICESSECOPYREQD",
    Frontend_msg: "Clear Driving license required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSENAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Driving license",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSEDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Driving license",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSEINCORRECT",
    Frontend_msg: "Incorrect Driving license uploaded",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DLICESSEADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Driving license",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "VALIDDLICESSEREQUIRED",
    Frontend_msg: "Valid Driving license required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARCOPYREQD",
    Frontend_msg: "Aadhar is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "CLEARAADHARCOPYREQD",
    Frontend_msg: "Clear Aadhar required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARDOBMISMATCH",
    Frontend_msg: "DOB Mismatch on Aadhar",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Aadhar",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARINCORRECT",
    Frontend_msg: "Incorrect Aadhar uploaded",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARNOMISSING",
    Frontend_msg: "Complete Aadhar Number Required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "AADHARADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Aadhar",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "PHONEBILLCOPYREQD",
    Frontend_msg: "Recent Telephone Bill or Mobile Bill is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "CLEARPHONECOPYREQD",
    Frontend_msg: "Clear Recent Telephone Bill or Mobile Bill required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "RECENTPHONEBILLREQD",
    Frontend_msg: "Recent Telephone Bill or Mobile Bill is required/Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "TELEPHONEBILLADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Recent Telephone Bill or Mobile Bill",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "TELEPHONEBILLNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Recent Telephone Bill or Mobile Bill",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "BANKPBCOPYREQD",
    Frontend_msg: "Bank Passbook or Statement is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "CLEARBANKPBCOPYREQD",
    Frontend_msg: "Clear Bank Passbook or Statement required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "PASSBOOKADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Bank Passbook or Statement",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "PASSBOOKNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Bank Passbook or Statement",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "RECENTPASSBOOKREQD",
    Frontend_msg: "Recent Bank Passbook or Statement is required/Bank Passbook",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "EBILLCOPYREQD",
    Frontend_msg: "Utility Bills is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "CLEAREBILLCOPYREQD",
    Frontend_msg: "Clear Utility Bills required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "RECENTEBILLREQD",
    Frontend_msg: "Recent Utility Bill required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "UTILITYBILLNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Utility Bills",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "UTILITYBILLADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Utility Bills",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "ACCOMODATIONLETTERCOPYREQD",
    Frontend_msg:
      "Accomodation allotment letter from Govt. Dept. is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "CLEARACCOMODATIONLETTERCOPYREQD",
    Frontend_msg:
      "Clear Accomodation allotment letter from Govt. Dept. required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "ACCOMODATIONLETTERADDRESSMISMATCH",
    Frontend_msg:
      "Address Mismatch on Accomodation allotment letter from Govt. Dept.",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "ACCOMODATIONLETTERNAMEMISMATCH",
    Frontend_msg:
      "Name Mismatch on Accomodation allotment letter from Govt. Dept.",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "PROPERTYTAXCOPYREQD",
    Frontend_msg: "Property or Municipal tax receipt is required/ Missing",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "CLEARPROPERTYTAXCOPYREQD",
    Frontend_msg: "Clear Property or Municipal tax receipt required",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "PROPERTYTAXADDRESSMISMATCH",
    Frontend_msg: "Address Mismatch on Property or Municipal tax receipt",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "PROPERTYTAXNAMEMISMATCH",
    Frontend_msg: "Name Mismatch on Property or Municipal tax receipt",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "PHOTOREQD",
    Frontend_msg: "Passport Size Photograph is required/ Missing",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "CLEARPHOTOREQD",
    Frontend_msg: "Clear Passport Size Photograph required",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Pan Card verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Passport Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Voter Id card Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Driving license Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Job Card issued by NREGA  Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg:
      "Letter issued by National population registrar Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Aadhar Card Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg:
      "Letter from Gazetted Officer with duly attested photograph  Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Passport Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "VoterId Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Driving License Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Aadhar Card Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Telephone Bill Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Bank Passbook Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Electricity Bill Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Accomodation Letterb Verification Completed",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Property or municipal tax letter Verification Completed",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "APPROVED",
    Frontend_msg: "Photo Verification Completed",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "IDENTITYPROOF",
    ReceivedStatusCd: "PENDING",
    Frontend_msg: "Please upload valid identity proof ",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ADDRESSPROOF",
    ReceivedStatusCd: "PENDING",
    Frontend_msg: "Please upload valid Address proof",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    ReceivedStatusCd: "PENDING",
    Frontend_msg: "Please upload valid Photograph",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    ReceivedStatusCd: "PENDING",
    Frontend_msg: "Please upload valid identity proof ",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    ReceivedStatusCd: "PENDING",
    Frontend_msg: "Please upload valid Address proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PAN Card",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Passport",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Voter ID card",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Driving license",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Job Card issued by NREGA",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Letter issued by National Population Register",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "Aadhar Card",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType:
      "Letter from Gazetted Officer with duly attested photograph of customer",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Passport",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Voter ID card",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Driving license",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Recent Telephone Bill or Mobile Bill",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Bank Passbook or Statement",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Utility Bills",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Aadhar Card",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Accomodation allotment letter from Govt. Dept.",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "Property or Municipal tax receipt",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
  {
    Document: "PHOTO",
    DocumentType: "Passport Size Photograph",
    ReceivedStatusCd: "DIGITALAPPROVED",
    Frontend_msg: "Document Digitally Approved",
  },
];

export const document_request_mapping = [
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PANCARD",
    docs_key: "Pan Card",
    Sub_docs: "PAN Card",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "PASSPORT",
    docs_key: "Passport",
    Sub_docs: "Passport",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "VOTEID",
    docs_key: " Voter ID card",
    Sub_docs: "Voter ID card",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "DLICESSE",
    docs_key: "Driving license",
    Sub_docs: "Driving license",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "JOBCARD",
    docs_key: "job Card issued by NREGA duly signed by Govt. Officer",
    Sub_docs: "Job Card issued by NREGA",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "LETTERHEAD",
    docs_key: "Letter issued by National Population Register",
    Sub_docs: "Letter issued by National Population Register",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "AADHARCARD",
    docs_key: "Aadhar Card",
    Sub_docs: "Aadhar Card",
    Docs_type: "Identity proof",
  },
  {
    Document: "IDENTITYPROOF",
    DocumentType: "GAZETTEOFFICER",
    docs_key:
      "Letter from Gazetted Officer with duly attested photograph of customer",
    Sub_docs:
      "Letter from Gazetted Officer with duly attested photograph of customer",
    Docs_type: "Identity proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PASSPORT",
    docs_key: "Passport",
    Sub_docs: "Passport",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "VOTEID",
    docs_key: "Voter ID card",
    Sub_docs: "Voter ID card",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "DLICESSE",
    docs_key: "Driving license",
    Sub_docs: "Driving license",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "AADHARCARD",
    docs_key:
      "Recent Telephone Bill / Postpaid Mobile Bill (not older than 2 months)",
    Sub_docs: "Recent Telephone Bill or Mobile Bill",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PHONEBILL",
    docs_key: "Bank Passbook/Statement",
    Sub_docs: "Bank Passbook or Statement",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "BANKPASSBOOK",
    docs_key:
      "Utility Bills (Electricity, Piped Gas, Water Bill - not older than 2 months)",
    Sub_docs: "Utility Bills",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "UTILITYBILL",
    docs_key: "Aadhar Card",
    Sub_docs: "Aadhar Card",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "ACCOMODATIONLETTER",
    docs_key: "Accomodation allotment letter from Govt. Dept.",
    Sub_docs: "Accomodation allotment letter from Govt. Dept.",
    Docs_type: "Address proof",
  },
  {
    Document: "KYCADDRESSPROOF",
    DocumentType: "PROPERTYTAX",
    docs_key: "Property or Municipal tax receipt",
    Sub_docs: "Property or Municipal tax receipt",
    Docs_type: "Address proof",
  },
  {
    Document: "PHOTO",
    DocumentType: "PHOTO",
    docs_key: "Passport Size Photograph",
    Sub_docs: "Passport Size Photograph",
    Docs_type: "Photo",
  },
];

export const activity_tracker_keys = [
  {
    ActivityTracker_key: "Pending HUMS UW Transfer",
    ActicityTracker_value: "Moved to underwriting",
  },
  {
    ActivityTracker_key: "Pending Proposal Data Entry",
    ActicityTracker_value:
      "Data Entry/Quality Check for application by Operations team",
  },
  {
    ActivityTracker_key: "Pending Proposal DE Fulfillment",
    ActicityTracker_value:
      "Documents received from customer at branch. Data entry by Operations team",
  },
  {
    ActivityTracker_key: "Pending QC",
    ActicityTracker_value:
      "Application details and documents review by Operations team",
  },
  {
    ActivityTracker_key: "Pending QC Fulfillment",
    ActicityTracker_value:
      "Application details and documents review by Operations team",
  },
  {
    ActivityTracker_key: "Pending Recon File",
    ActicityTracker_value: "Pre-Policy Medical check up reports triggered",
  },
  {
    ActivityTracker_key: "Pending STP",
    ActicityTracker_value: "Pending Issuance",
  },
  {
    ActivityTracker_key: "Pending UW PPMC",
    ActicityTracker_value: "Pre-Policy Medical Check Up triggered",
  },
  {
    ActivityTracker_key: "PPMC UW Waiver",
    ActicityTracker_value:
      "Request for waiver on Pre-Policy Medical Check-up received",
  },
  {
    ActivityTracker_key: "PPMC UW Waiver Approval ",
    ActicityTracker_value: "Waiver on Pre-Policy Medical Check-up approved",
  },
  {
    ActivityTracker_key: "PPMC Waiver",
    ActicityTracker_value:
      "Request for waiver on Pre-Policy Medical Check-up received",
  },
  {
    ActivityTracker_key: "Upload Failure",
    ActicityTracker_value: "Document upload has failed, re-upload triggered",
  },
  {
    ActivityTracker_key: "Waiting for Deposit",
    ActicityTracker_value: "Cheque payment processing was initiated ",
  },
  {
    ActivityTracker_key: "Waiting for Issuance",
    ActicityTracker_value: "Waiting for Issuance",
  },
  {
    ActivityTracker_key: "Pending Receipt Entry",
    ActicityTracker_value: "Payment receipt creation was initiated",
  },
  {
    ActivityTracker_key: "Sent back to DE",
    ActicityTracker_value: "Case moved to Operations team",
  },
  {
    ActivityTracker_key: "Pending De-Dup Check",
    ActicityTracker_value: "Case moved to Dedupe queue",
  },
  {
    ActivityTracker_key: "HUMS Failure",
    ActicityTracker_value: "Internal system error occurred in HUMS ",
  },
  {
    ActivityTracker_key: "Pending Payment Portal",
    ActicityTracker_value: "Moved to receipt info waiting bucket",
  },
  {
    ActivityTracker_key: "Central Ops",
    ActicityTracker_value: "Case moved to Central Operations",
  },
  {
    ActivityTracker_key: "Pending UW",
    ActicityTracker_value: "Case moved to UW team ",
  },
  {
    ActivityTracker_key: "Pending PPMC",
    ActicityTracker_value:
      "Case moved to Pre-Policy Medical Check Up (PPMC) bucket",
  },
  {
    ActivityTracker_key: "Pending Customer Requirement",
    ActicityTracker_value: "Additional information/requirement was triggered",
  },
  {
    ActivityTracker_key: "PPMC Waiver Approval ",
    ActicityTracker_value: "Waiver approval request received",
  },
  {
    ActivityTracker_key: "Pending HRP Redemption",
    ActicityTracker_value: "Moved to HRP redemption bucket",
  },
  {
    ActivityTracker_key: "Policy Pre Issuance",
    ActicityTracker_value: "Policy Pre Issuance",
  },
  {
    ActivityTracker_key: "Policy Pending Payment Clearance",
    ActicityTracker_value: "Receipt clearance awaited",
  },
  {
    ActivityTracker_key: "DOCSCR",
    ActicityTracker_value: "Documents under scrutiny",
  },
  {
    ActivityTracker_key: "DOCSCRPEN",
    ActicityTracker_value: "Document awaited from customer",
  },
  {
    ActivityTracker_key: "Document Scrutiny",
    ActicityTracker_value: "Documents under scrutiny",
  },
  {
    ActivityTracker_key: "Document Scrutiny Pending",
    ActicityTracker_value: "Document awaited from customer",
  },
];

export const pending_with_keys = [
  {
    status_code: "Add Info Received",
    pending_with: "Operations",
  },
  {
    status_code: "Add Info Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC Received",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC Unsuccessful",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC + Add Info Received",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC Received + Add Info Pending",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC Pending + Add Info Recevied",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC + Add Info Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "Incomplete PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "Incomplete PPMC + Add Info Pending",
    pending_with: "Operations",
  },
  {
    status_code: "Incomplete PPMC + Add info received",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Cust Acceptance Received",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Cust Acceptance Rejected",
    pending_with: "Operations",
  },
  {
    status_code: "Add Info Pending",
    pending_with: "Customer",
  },
  {
    status_code: "Add Info Waiver Approved",
    pending_with: "Customer",
  },
  {
    status_code: "Add Info Waiver Rejected",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC Pending",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC Waiver Approved",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC Waiver Rejected",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC + Add Info Pending",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC + Add Info Waiver Approved",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC + Add Info Waiver Rejected",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC + Add Info Partial Waiver Approved",
    pending_with: "Customer",
  },
  {
    status_code: "Referred  To Sr Underwriter",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Loading Waived",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Sp Cond Waived",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete_Loading + Sp Cond Waived",
    pending_with: "Operations",
  },
  {
    status_code: "UW Pending",
    pending_with: "Operations",
  },
  {
    status_code: "UW Complete",
    pending_with: "Customer",
  },
  {
    status_code: "UW Complete_Cust Acceptance Awaited",
    pending_with: "Customer",
  },
  {
    status_code: "Referral response recd",
    pending_with: "Operations",
  },
  {
    status_code: "New APP",
    pending_with: "Operations",
  },
  {
    status_code: "New App + PPMC Pending",
    pending_with: "Customer",
  },
  {
    status_code: "Approve STP",
    pending_with: "Operations",
  },
  {
    status_code: "New Renewal App",
    pending_with: "Operations",
  },
  {
    status_code: "Renewals Pending",
    pending_with: "Operations",
  },
  {
    status_code: "New Renewal App + PPMC Pending ",
    pending_with: "Customer",
  },
  {
    status_code: "Renewals PPMC Pending",
    pending_with: "Customer",
  },
  {
    status_code: "RenewalUWPending+PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "TeleUWPending",
    pending_with: "Customer",
  },
  {
    status_code: "Send back to Ops",
    pending_with: "Operations",
  },
  {
    status_code: "OpsResponseRequirementComplete",
    pending_with: "Operations",
  },
  {
    status_code: "OpsResponseRequirementIncomplete",
    pending_with: "Operations",
  },
  {
    status_code: "New App+PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "UWPending+PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "NewRenewalApp+PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "Send back to PPMC",
    pending_with: "Customer",
  },
  {
    status_code: "Add Info Received + PPMC Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "Add Info Waiver Requested + PPMC Waiver Requested",
    pending_with: "Operations",
  },
  {
    status_code: "NewAppTeleUWPending",
    pending_with: "Customer",
  },
  {
    status_code: "TeleUWComplete",
    pending_with: "Customer",
  },
  {
    status_code: "RetryCustomer",
    pending_with: "Customer",
  },
  {
    status_code: "TeleUWattemptedCustomerNotContactable",
    pending_with: "Customer",
  },
  {
    status_code: "AutoRejected",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC_WAIVER_REQUESTED_ADD_INFO_PENDING",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC_PENDING_ADDINO_WAIVER_REQUESTED",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC_RECEIVED_ADDINFO_WAIVER_REQUESTED",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC_WAIVER_APPROVED_ADD_INFO_PENDING",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC_WAIVER_APPROVED_ADD_INFO_RECEVIED",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC_WAIVER_REJECTED_ADD_INFO_PENDING",
    pending_with: "Customer",
  },
  {
    status_code: "PPMC_WAIVER_REJECTED_ADD_INFO_RECEIVED",
    pending_with: "Operations",
  },
  {
    status_code: "PPMC_WAIVER_APPROVED_ADD_INFO_WAIVER_REQUESTED",
    pending_with: "Operations",
  },
];

export const customerOfferKeys_mapping = [
  {
    status_code: "ALTDELRIDER",
    pending_with: "Customer",
  },
  {
    status_code: "ALTDELINSURED",
    pending_with: "Customer",
  },
  {
    status_code: "ALTSIPLAN",
    pending_with: "Operations",
  },
  {
    status_code: "ALTADDADDON",
    pending_with: "Customer",
  },
  {
    status_code: "ALTDELADDON",
    pending_with: "Operations",
  },
  {
    status_code: "ALTSIRIDER",
    pending_with: "Customer",
  },
  {
    status_code: "ALTCOVERTYPE",
    pending_with: "Operations",
  },
];

export const frontend_docs_key_mapping = [
  {
    key_Doctype: "PANCARD",
    msg: "Pan Card",
  },
  {
    key_Doctype: "PASSPORT",
    msg: "Passport",
  },
  {
    key_Doctype: "VOTEID",
    msg: "Voter ID card",
  },
  {
    key_Doctype: "DLICESSE",
    msg: "Driving license",
  },
  {
    key_Doctype: "JOBCARD",
    msg: "Job Card issued by NREGA duly signed by Govt. Officer",
  },
  {
    key_Doctype: "LETTERHEAD",
    msg: "Letter issued by National Population Register",
  },
  {
    key_Doctype: "AADHARCARD",
    msg: "Aadhar Card",
  },
  {
    key_Doctype: "GAZETTEOFFICER",
    msg: "Letter from Gazetted Officer with duly attested photograph of customer",
  },
  {
    key_Doctype: "PHONEBILL",
    msg: "Recent Telephone Bill / Postpaid Mobile Bill (not older than 2 months)",
  },
  {
    key_Doctype: "BANKPASSBOOK",
    msg: "Bank Passbook/Statement",
  },
  {
    key_Doctype: "UTILITYBILL",
    msg: "Utility Bills (Electricity, Piped Gas, Water Bill - not older than 2 months)",
  },
  {
    key_Doctype: "ACCOMODATIONLETTER",
    msg: "Accomodation allotment letter from Govt. Dept.",
  },
  {
    key_Doctype: "PROPERTYTAX",
    msg: "Property or Municipal tax receipt",
  },
  {
    key_Doctype: "PHOTO",
    msg: "Passport Size Photograph",
  },
];

export const Frontend_msg_for_document = [
  {
    key_Doctype: "IDENTITYPROOF",
    msg: "Identity Proof",
  },
  {
    key_Doctype: "KYCADDRESSPROOF",
    msg: "KYC Address Proof",
  },
  {
    key_Doctype: "PHOTO",
    msg: "Photo",
  },
];

export const mapping_appointment_details = [
  {
    SysCode: "APPOINTMENTPENDING",
    msg: "Medical tests pending",
    pendingMsg: "Customer",
    isPendingWith: true,
    isAppointmentButton: true
  },
  {
    SysCode: "APPOINTMENTCONFIRMED",
    msg: "Appointment Confirmed",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "CUSTOMERNOTREACHABLE",
    msg: "Customer Not Reachable",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "CUSTOMERDENIEDPPMC",
    msg: "Customer denied PPMC",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "POLICYCANCELLATIONREQUEST",
    msg: "Policy cancellation request",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "NOSHOWBYPHLEBOTOMIST",
    msg: "No show by phlebotomist",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "SHOWBYPHLEBO",
    msg: "Phlebotomist reached for sample collection",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "LATESHOWBYPHLEBOTOMIST",
    msg: "Late show by Phlebotomist",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "NOSHOWBYCUSTOMER",
    msg: "No show by customer",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "SESSIONSTARTED",
    msg: "Session started",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "ALTERNATEIDPROOFNOTMATCHING",
    msg: "Alternate ID proof not matching",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "IDCARDNOTAVAILABLE",
    msg: "ID Card Not Available",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "IDPROOFMATCHING",
    msg: "ID proof matching",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "ALLSAMPLESCOLLECTED",
    msg: "All Samples collected",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "PARTIALSHOW",
    msg: "Partial show",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "INSUFFICIENTSAMPLE",
    msg: "Insufficient Sample",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "LOSTSAMPLE",
    msg: "Lost Sample",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "SAMPLESTESTEDREPORTSPENDING",
    msg: "Samples tested /Reports pending",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "REPORTSUPLOADED",
    msg: "Reports Uploaded",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
  {
    SysCode: "DIGITALDATARECEIVED",
    msg: "Digital Data received",
    pendingMsg: null,
    isPendingWith: false,
    isAppointmentButton: false
  },
];
